export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      pageTitle: 'Login',
      layout: 'full',
      requireNotAuth: true,
    },
  },
]
